import { render, staticRenderFns } from "./TeslaCoilViz.vue?vue&type=template&id=68362ef2&scoped=true"
import script from "./TeslaCoilViz.vue?vue&type=script&lang=js"
export * from "./TeslaCoilViz.vue?vue&type=script&lang=js"
import style0 from "./TeslaCoilViz.vue?vue&type=style&index=0&id=68362ef2&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "68362ef2",
  null
  
)

export default component.exports